module.exports = __webpack_public_path__ + "img/001.c7a6d0f7.png";